import { Component, Input } from '@angular/core';
import { IConfirmDialogConfig } from '../../interfaces/confirm-dialog-config/iconfirm-dialog-config';
import { MatDialogRef } from '@angular/material/dialog';
import { SimpleConfirmDialogComponent } from './simple-confirm-dialog.component';

@Component({
    selector: 'cas-confirm-dialog-container',
    templateUrl: './confirm-dialog-container.component.html',
    styleUrls: ['./confirm-dialog-container.component.scss']
})
export class ConfirmDialogContainerComponent {
    @Input() private dialogRef: MatDialogRef<SimpleConfirmDialogComponent>;
    @Input() public data: IConfirmDialogConfig;

    public get messagesIsArray() {
        return Array.isArray(this.data.message);
    }

    public close() {
        this.dialogRef.close();
    }

    public confirm() {
        this.dialogRef.close(true);
    }
}
